import {
  SET_THEME_MODE,
  SET_IS_SYSTEM_THEME,
  SET_IS_LOGOUT,
  SET_COMPANY_LOGO
} from "redux/constants/portal";
import { THEME_TYPES } from "constants/theme";

const initialState = {
  themeMode: THEME_TYPES.DARK,
  isSystemTheme: false,
  isLogout: false,
  companyLogo: null
};

const settings = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_THEME_MODE:
      return {
        ...state,
        themeMode: payload
      };
    case SET_IS_SYSTEM_THEME:
      return {
        ...state,
        isSystemTheme: payload
      };
    case SET_IS_LOGOUT:
      return {
        ...state,
        isLogout: payload
      };
    case SET_COMPANY_LOGO:
      return {
        ...state,
        companyLogo: payload
      };
  }
  return state;
};

export default settings;
